import maButtonsNextActions from '@/components/button-blue'
import maAccordion from '@/components/accordion'
import maModal from '@/components/modal'
import maNavbarStepper from '@/components/navbarStepper'
import { mapState, mapActions } from 'vuex'
import downloadBlobFile from '@/utils/downloadBlobFile'
import { apiGetPdfMaterial } from '@/modules/Claim/services/pdf'
import { billmaChangeE2EFlow } from '@/modules/Claim/services/sinister'

import {
  FLOW_MODULE_NAME,
  WARRANTY_MODULE_NAME,
  WARRANTY_GET_RESULT_DECLARATION
} from '@/store/types'
import flowMixin from '@/modules/Flow/mixins/flowMixin'
import { FLOW_TRANSITIONS } from '@/modules/Flow/constants'
import cloneDeep from 'lodash/cloneDeep'

export default {
  name: 'damageValidation',

  mixins: [flowMixin],

  components: {
    maButtonsNextActions,
    maAccordion,
    maModal,
    maNavbarStepper
  },
  data() {
    return {
      isMobilierDamage: false,
      damagesList: [],
      damagesArray: [],
      damagesImmobilier: []
    }
  },

  computed: {
    ...mapState(WARRANTY_MODULE_NAME, {
      stateWarrantyResultDeclaration: 'resultDeclaration',
      stateWarrantySinisterSummary: 'sinisterSummary',
      stateWarrantyWarranties: 'warranties'
    }),
    ...mapState(FLOW_MODULE_NAME, {
      stateFlowState: 'flowState',
      stateFlowViewOptions: 'flowViewOptions'
    }),
    paragraphs: function () {
      return this.getFlowViewContent.filter((c) => c.type === 'PARAGRAPH') || []
    },
    title: function () {
      const titleContent = this.getFlowViewContent.find(
        (c) => c.type === 'TITLE'
      )
      return titleContent ? titleContent.literal : ''
    },
    text1: function () {
      return this.paragraphs[0] ? this.paragraphs[0].literal : ''
    },
    text2: function () {
      return this.paragraphs[1] ? this.paragraphs[1].literal : ''
    },
    checkDamages() {
      if (
        (this.stateWarrantyWarranties.hasOwnProperty('embellishments') ||
          this.stateWarrantyWarranties.hasOwnProperty('immobilier')) &&
        this.stateWarrantyWarranties.hasOwnProperty('mobilier')
      ) {
        return true
      }
    },
    isAllDamages() {
      try {
        return (
          (this.stateWarrantyWarranties.hasOwnProperty('embellishments') ||
            this.stateWarrantyWarranties.hasOwnProperty('immobilier')) &&
          this.stateWarrantyWarranties.hasOwnProperty('mobilier')
        )
      } catch {
        return false
      }
    },
    isFrais() {
      return (
        this.stateFlowViewOptions.smart_values.frais.compensation_base !== 0
      )
    }
  },

  methods: {
    ...mapActions(WARRANTY_MODULE_NAME, {
      actGetResultDeclaration: WARRANTY_GET_RESULT_DECLARATION
    }),

    handlePrimaryButtonClick() {
      if (this.isFrais) {
        this.goToNextState(FLOW_TRANSITIONS.SHOW_FRAIS)
      } else {
        this.goToNextState(FLOW_TRANSITIONS.SHOW_RESUME)
      }
    },

    handlePrimaryButtonClickMobilier() {
      if (this.isAllDamages) {
        this.goToNextState(FLOW_TRANSITIONS.SHOW_MOBILIER)
      } else {
        this.goToNextState(FLOW_TRANSITIONS.SHOW_RESUME)
      }
    },

    async handleSecondaryButtonClick() {
      if (this.isE2EFlow) {
        await billmaChangeE2EFlow(this.getSinisterId, 'immobilier')
      }
      this.goToNextState(FLOW_TRANSITIONS.CALLBACK_REQUEST)
    },

    handleTertiaryButtonClick() {
      this.goToNextState(FLOW_TRANSITIONS.SHOW_COMPENSATION_TYPE)
    },

    /**
         * This method handles the API call related to generate a pdf materials
         * list report.
         */
    handleClickMaterialList() {
      apiGetPdfMaterial(this.getSinisterId).then((data) => {
        downloadBlobFile(data, 'Recapitulatif_budget_Allianz.pdf')
      })
    },

    setDamagesData() {
      this.damagesList = cloneDeep(this.stateWarrantyWarranties)
    },
    handleOpenDescriptionModal() {
      this.$refs.modalDescription.showModal = true
    },
    handleCloseDescriptionModal() {
      this.$refs.modalDescription.showModal = false
    },

    handleDescriptionDamages() {
      this.damagesImmobilier = cloneDeep(
        this.stateFlowViewOptions.smart_values.inmobilier
      )
    },

    replaceDots(value) {
      if (value) {
        if (typeof value === 'number') {
          value = value.toString()
        }
        let valueComma = value.replace(/\./g, ',')

        return valueComma
      }
    }
  },

  /**
   * Updates warranty and user state with url params
   */
  mounted() {
    this.setDamagesData()
    const sinisterId = this.getSinisterId
    this.actGetResultDeclaration(sinisterId)
    this.handleDescriptionDamages()
  }
}
